import { render } from "./ShowCourseDetails.vue?vue&type=template&id=0eebc0e6&scoped=true"
import script from "./ShowCourseDetails.vue?vue&type=script&lang=js"
export * from "./ShowCourseDetails.vue?vue&type=script&lang=js"

import "./ShowCourseDetails.vue?vue&type=style&index=0&id=0eebc0e6&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eebc0e6"]])

export default __exports__